import { h } from 'preact'

const PrerenderLoading = () => {
  return (
    <div class='loading-fade-in'>
      <div class='ph-item'>
        <div class='ph-col-12'>
          <div class='ph-row'>
            <div class='ph-picture py-6' />
          </div>
        </div>
      </div>
      <section class='mt-5 mb-5'>
        <div class='container'>
          <div class='row'>
            <div class='col ph-item'>
              <div class='ph-col-12'>
                <div class='ph-row'>
                  <div class='ph-col-6 big' />
                  <div class='ph-col-6 big empty' />
                  <div class='ph-col-4' />
                  <div class='ph-col-4 big empty' />
                  <div class='ph-col-12' />
                  <div class='ph-col-12' />
                  <div class='ph-col-12' />
                  <div class='ph-col-10' />

                  <div class='ph-col-12 empty' />

                  <div class='ph-col-12' />
                  <div class='ph-col-12' />
                  <div class='ph-col-12' />
                  <div class='ph-col-10' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default PrerenderLoading
